<script lang="ts">
    import { Personal, Views, href } from "../../../utils/Constant/Constant";
    import AddCategory from "./AddCategory.svelte";
    import data from "../../../Data/Contacts/Contacts.json"
    import Link from "svelte-link";
    import {contactMenuId} from "../../../store"
    import NewContacts from "./NewContacts.svelte";
    const handleTab = (id:string) =>{
        contactMenuId.update(value => value = id)
    }
</script>
<ul class="nav main-menu contact-options" role="tablist">
    <NewContacts/>
    <li class="nav-item">
        <span class="main-title"> {Views}</span>
    </li>
    <li>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <Link href={href} id="personal-tab" on:click={()=>handleTab("personal-tab")}>
            <span class="title"> {Personal}</span>
        </Link>
    </li>
    <AddCategory />
    {#each data.contactmenudata as contactItem }
        <li>
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <Link href={href} id={contactItem.id} on:click={()=>handleTab(contactItem.id)}>
                <span class="title"> {contactItem.name}</span>
            </Link>
        </li>
    {/each}
</ul>